// Navigation reads go through /api/strapi-nav on both passes, unlike
// fetchQueryPath which talks to Strapi directly during SSR. Routing the render
// through the endpoint is what makes its cache effective — a direct call would
// bypass it, which is exactly how the menus and footer came to be 93% of all
// CMS traffic. During SSR $fetch resolves this in-process, so going through the
// route costs no extra network hop.
export const fetchNavPath = (path: string) => {
  return $fetch('/api/strapi-nav', { query: { path } })
}
